module.exports = __webpack_public_path__ + "static/media/InCasino.f9e7f339.svg";